document.addEventListener('DOMContentLoaded', function () {

    class ArticleProgressBar extends HTMLElement {
        constructor() {
            super();

            this.progressBar = this.querySelector(".article-progress-bar__fill");
            this.article = document.querySelector("#main-article-content");

            this.handleScroll = this.onScroll.bind(this);
        }

        connectedCallback() {
            window.addEventListener('scroll', this.handleScroll);
            window.addEventListener('resize', this.handleScroll);
        }

        disconnectedCallback() {
            window.removeEventListener('scroll', this.handleScroll);
            window.removeEventListener('resize', this.handleScroll);
        }

        onScroll() {
            const article = this.article || document.querySelector("#main-article-content");
            const progressBar = this.progressBar || document.querySelector('#article-progress-bar');

            if (!article || !progressBar) return;

            const scrollTop = window.scrollY || window.pageYOffset;
            const articleTop = article.offsetTop;
            const articleHeight = article.offsetHeight;
            const viewportHeight = window.innerHeight;

            const earlyOffset = 200;
            const distanceScrolled = scrollTop - (articleTop - earlyOffset);
            const totalScrollable = articleHeight - viewportHeight + earlyOffset;

            const progress = Math.min(100, Math.max(0, (distanceScrolled / totalScrollable) * 100));
            this.classList.toggle('visibility-hidden', progress === 0);
            this.style.setProperty('--progress-value', `${progress}%`);

        }
    }
    customElements.define('article-progress-bar', ArticleProgressBar);

})